import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Text from 'components/common/Text'

const PremiumBenefit = props => {
  const { title, text } = props

  return (
    <Div paddingTop={12}>
      <Text size={14} color="black">{title}</Text>
      <Text size={14} color="grey">{text}</Text>
    </Div>
  )
}

PremiumBenefit.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}

export default PremiumBenefit



// WEBPACK FOOTER //
// ./src/components/modal/PremiumBenefit.js